import Vue from 'vue'
import api from '../api'

const ChatModule = {
  state: {
    chats: {},
    chatList: [],
    messages: {},
    chatId: undefined
  },
  mutations: {
    setChats (state, chats) {
      chats.forEach(chat => {
        chat.messages = chat.messages || []
        Vue.set(state.chats, chat.chatId, chat)
        state.chatList.push(chat.chatId)
      })
    },

    setChatId (state, { chatId }) {
      state.chatId = chatId
      Vue.set(state.chats[chatId].userData, "newMessages", 0)
    },

    addChatMessages (state, { chatId, messages }) {
      if (state.chats[chatId]) {
        for (const message of messages) {
          const messageId = `${chatId}:${message.messageId}`
          state.chats[chatId].messages.push(messageId)
          Vue.set(state.messages, messageId, message)
        }
      } else {
        state.error = { message: 'Chat not found' }
      }
    },

    newMessage (state, message) {

      if (message.chatId === state.chatId) {
        // add message to current chat
        const messageId = `${message.chatId}:${message.messageId}`
        state.chats[message.chatId].messages.push(messageId)
        Vue.set(state.messages, messageId, message)
      } else {
        // update unread count
        state.chats[message.chatId].userData.newMessages += 1
      }
    },

    socket_chat_update (state, payload) {
      const { chatId } = payload
      const messages = state.chats[chatId] ? state.chats[chatId].messages || [] : []
      const userData = state.chats[chatId] ? state.chats[chatId].userData || {} : {}
      Vue.set(state.chats, chatId, { messages, userData, ...payload })

      if (state.chatList.findIndex(id => id === chatId) < 0) {
        state.chatList.push(chatId)
      }
    },

    socket_message_update (state, payload) {

    },
  },

  actions: {
    async socket_message ({ commit, getters, state }, message ) {
      commit('setLoading', true)
      // console.log('new message', message)

      try {
        if (!state.chats[message.chatId]) {
          const response = await api.findChat(getters.user.token, message.userId)
          // console.log('find chat', message.userId, response.data)
          commit('socket_chat_update', response.data.chat)
        }
        commit('newMessage', message)

      } catch (error) {
        commit('setError', error)
      }
      commit('setLoading', false)
    },
    async loadChats ({ commit, getters }) {
      commit('setLoading', true)
      try {
        const response = await api.getChats(getters.user.token)
        commit('setChats', response.data.chats)
      } catch (error) {
        commit('setError', error)
      }
      commit('setLoading', false)
    },

    async loadNewMessages ({ commit, getters }, { chatId, messageId }) {
      commit('setLoading', true)
      commit('clearError')
      try {
        const response = await api.getChatMessages(chatId, getters.user.token, {
          mode: 'fromMessageId',
          data: messageId,
          sort: 1
        })
        // console.log('messages: ',response.data.messages)
        commit('addChatMessages', { chatId, messages: response.data.messages })
      } catch (error) {
        commit('setError', error)
      }
      commit('setLoading', false)
    },

    openChat({ commit }, { chatId }) {
      commit('setLoading', true)
      commit('clearError')

      api.openChat(chatId)
        .then(() => {
          commit('setChatId', { chatId })
        })
        .catch(error => {
          commit('setError', error)
        }) 
      commit('setLoading', false)
    },

    sendMessage ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      api.sendMessage(payload).then()
        .catch(error => {
          commit('setError', error)
        })
      commit('setLoading', false)
    },

    sendFile ({ commit, getters }, { message, fileData } ) {
      commit('setLoading', true)
      commit('clearError')
      api.sendFile(getters.user.token, message, fileData).then()
        .catch(error => {
          console.log(error)
          commit('setError', error)
        })

      commit('setLoading', false)
    },

    createPrivateChat({ commit, getters }, { userId }) {
      commit('setLoading', true)
      commit('clearError')
      api.findChat(getters.user.token, userId)
        .then(data => {
          console.log(data.data.chat)
          commit("socket_chat_update", data.data.chat)
        })
        .catch(error => {
          console.log(error)
          commit('setError', error)
        })

      commit('setLoading', false)
    },

    createPublicChat ({ commit }, { title, status, subscribers }) {
      commit('setLoading', true)
      commit('clearError')
      api.newChat(title, status, subscribers)
        .then(data => {
          console.log(data)
        })
        .catch(error => {
          console.log(error)
          commit('setError', error)
        })

      commit('setLoading', false)
    }
  },

  getters: {
    chats (state) {
      return state.chatList.map(chatId => state.chats[chatId])
    },
    chat (state) {
      return state.chatId ? state.chats[state.chatId] : {}
    },
    messages (state) {
      return (chatId) => {
        const chat = state.chats[chatId]
        return chat ? chat.messages.map(messageId => state.messages[messageId]) : []
      }
    }
  }
}

export default ChatModule
